import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-52a97408")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_input_area = _resolveComponent("input-area")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_input_area, {
      modelValue: _ctx.dedication,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dedication = $event)),
      name: _ctx.label,
      class: "w-auto",
      label: _ctx.label,
      required: false
    }, null, 8, ["modelValue", "name", "label"])
  ]))
})